import PropTypes from "prop-types"
import { useStateMachine } from "little-state-machine"
import { useMediaQuery } from "@mui/material"
import { updateAction } from "utils/littleStateMachine"
import { LG } from "consts/breakpoints"
import SamplesListDesktop from "./components/SamplesListDesktop"
import SamplesListMobile from "./components/SamplesListMobile"
import { SAMPLES_TO_SHOW_IN_DESKTOP, SAMPLES_TO_SHOW_IN_MOBILE } from "../../constants/samples"
import { useRef } from "react"

const SamplesList = ({
  samplesDesktop = SAMPLES_TO_SHOW_IN_DESKTOP,
  samplesMobile = SAMPLES_TO_SHOW_IN_MOBILE
}) => {
  const isMobile = useMediaQuery(LG)
  const { state, actions } = useStateMachine({ updateAction })
  const staticSample = useRef()

  const handleClick = (event, sample) => {
    actions.updateAction({
      sampleDetails: sample
    })

    staticSample.current = state.sampleDetails
    event.preventDefault()
  }

  return (
    <div className="d-lg-flex p-0 flex-wrap col-12 h-100 pb-0">
      {!isMobile ? (
        <SamplesListDesktop
          staticSampleData={staticSample}
          samples={samplesDesktop}
          handleClick={handleClick}
        />
      ) : (
        <SamplesListMobile samples={samplesMobile} handleClick={handleClick} />
      )}
    </div>
  )
}

SamplesList.propTypes = {
  samplesDesktop: PropTypes.array.isRequired,
  samplesMobile: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired
}

export default SamplesList
